import React from "react";
import { MDBFooter, MDBContainer, MDBIcon, MDBBtn } from "mdb-react-ui-kit";

function Footer() {
  return (
    <div>
      <MDBFooter
        className="text-center text-white"
        style={{ backgroundColor: "#f1f1f1" }}
      >
        <MDBContainer className="pt-4">
          <section className="mb-4">

            <MDBBtn
              rippleColor="dark"
              color="link"
              floating
              size="lg"
              className="text-dark m-1"
              href="https://www.instagram.com/chriistatto?igsh=MWNsenIwbmNiZDBrZg=="
              role="button"
            >
              <MDBIcon fab className="fa-instagram" />
            </MDBBtn>
          </section>
        </MDBContainer>

        <div
          className="text-center text-dark p-3"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
        >
          © 2026 Copyright: Elchriis
        </div>
      </MDBFooter>
    </div>
  );
}

export default Footer;
